import { API_PATHS } from "../constants/api-paths";
import { logCustomAttributeToNewRelic } from "../utils/logging";
import { IResponse, encryptedRequest } from "../core/api.client";

export interface IAutofetchRequest {
  mobileNo: string;
  customerFullName: string;
  csRequestId: number;
}

export interface IAutofetchResponse {
  landingPage: string;
  crossSellProduct: string;
  customerDetails: ICustomerDetails;
  customerType: string;
  laststage: string;
  csRequestId: string;
  currentStage: string;
  nextStage: string;
}

export interface ICustomerDetails {
  firstname: string;
  lastname: string;
  pan: string;
  dob: string;
  city: string;
  gender: string;
  customertype: string;
  customerFullName: string;
  pinCode: string;
  employmenttype: string;
}

export const getPanDetails = async (
  data: IAutofetchRequest
): Promise<IResponse<IAutofetchResponse> | null> => {
  try {
    const response = await encryptedRequest<IAutofetchResponse>({
      method: "POST",
      url: API_PATHS.autofetchDetails,
      data,
    });
    return response;
  } catch (error) {
    logCustomAttributeToNewRelic(
      "AUTOFETCH_DETAILS_API",
      JSON.stringify({
        status: "ERROR",
        URL: window.location.href,
        mobileNo: data.mobileNo,
        errorMessage: (error as Error).message,
      })
    );
    return null;
  }
};
